var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"livestream-left"},[_c('v-btn',{staticClass:"back-button",attrs:{"icon":"","color":"white"},on:{"click":function($event){return _vm.goBack()}}},[_c('i',{staticClass:"fas fa-chevron-left"})]),_c('GuestCard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }